export enum EPhonePlatform {
  sakari = "sakari",
  twilio = "twilio",
  callr = 'callr'
}

export const phonePlatformAsString = (phonePlatform: EPhonePlatform): string => {
  switch (phonePlatform) {
    case EPhonePlatform.sakari:
      return "Sakari";
    case EPhonePlatform.twilio:
      return "Twilio";
    case EPhonePlatform.callr:
      return "Callr";
    default:
      return "";
  }
};

